import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import sendRecRequest from "./components/sendRecRequest.vue";
import showPayTable from "./components/showPayTable.vue";
import DataOptions from "../../components/timeList/dataOptions.vue";
import { getPayRequest } from "@/api/payItem";
import infoList from "../../mixins/infoList";
export default {
  name: "payRequest",
  mixins: [infoList],
  components: {
    showPayTable: showPayTable,
    sendRecRequest: sendRecRequest,
    DataOptions: DataOptions
  },
  data: function data() {
    return {
      listApi: getPayRequest,
      //点击发送个人邮件,弹出框
      personalDialog: false,
      formTime: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      options: [{
        id: 0,
        label: "全部"
      }, {
        id: 1,
        label: "待审批"
      }, {
        id: 2,
        label: "审批驳回"
      }, {
        id: 3,
        label: "审批通过"
      }],
      approve_state: 0,
      editAllInfo: {},
      tableInfo: [],
      //充值申请信息包含
      formInfoPay: {
        id: 0,
        pay_item_id: "",
        //充值项ID
        //role_type: 1, //1:角色id,2:角色名
        title: "",
        //申请标题
        reason: "",
        //申请理由
        role_list: [{
          server_id: "",
          role_id: ""
        }]
      }
    };
  },
  created: function created() {
    this.queryBtn();
  },
  methods: {
    queryBtn: function queryBtn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.searchInfo.sdate = _this.formTime[0];
              _this.searchInfo.edate = _this.formTime[1];
              _this.searchInfo.approve_state = _this.approve_state;
              _context.next = 5;
              return _this.getTableData();
            case 5:
              _this.tableInfo = _this.tableData;
              if (!_this.tableInfo) {
                _this.$message({
                  message: "暂无数据"
                });
              } else if (_this.tableInfo && _this.tableInfo.length === 0) {
                _this.$message({
                  message: "暂无数据"
                });
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //打开邮件
    sendSomeEmail: function sendSomeEmail() {
      var _this2 = this;
      //1：发送申请
      this.editAllInfo = {
        formInfo: this.formInfoPay,
        isEditPage: false
      };
      this.personalDialog = true;
      this.$nextTick(function () {
        _this2.$refs.child.init(_this2.editAllInfo);
      });
    },
    //充值后的返回关闭弹出框
    backPersonEmail: function backPersonEmail(e) {
      this.queryBtn();
      this.personalDialog = e.dialogFormVisible;
    },
    sendData: function sendData(e) {
      var _this3 = this;
      this.editAllInfo = {
        formInfo: e,
        isEditPage: true
      };
      this.personalDialog = true;
      this.$nextTick(function () {
        _this3.$refs.child.init(_this3.editAllInfo);
      });
    },
    //弹出页面需求
    openPop: function openPop() {
      this.$notify({
        title: "充值申请功能",
        dangerouslyUseHTMLString: true,
        message: "<div>(1)可以根据玩家Id+服务器Id，玩家名+服务器名，两种形式发送充值申请。</div>" + "<div>(2)可支持输入多个玩家同时发送，按文本输入，一行表示一个玩家，每一行玩家信息填入 Id,对应服务器Id 或者 角色名称,对应服务器id</div>" + "<div>（3）申请需要填写，标题，申请理由</div>" + "<div>（4）单次申请只能申请一个充值项，充值项配置信息从xcpGameManager/gamePayConfig列表选择</div>" + "<div>(5)发起申请后，申请进入到待审核状态</div>" + "<div>(6)提交申请时，需先校验玩家信息是否存在</div>",
        duration: 0
      });
    }
  }
};